import { t } from "@lingui/core/macro";
import type { LayoutChangeEvent } from "react-native";

import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import type { LoyaltyReward } from "../LoyaltyRewardsModal";
import { RewardRow } from "./RewardRow";

type RewardsMenuProps = {
  rewards: readonly LoyaltyReward[];
  pointTerminologyOne: string;
  pointTerminologyOther: string;
  readOnly: boolean;
  onSelectReward?: (reward: LoyaltyReward) => void;
  pointsPillWidth: number | undefined;
  onPointsPillLayout: (event: LayoutChangeEvent) => void;
};

export const RewardsMenu = ({
  rewards,
  pointTerminologyOne,
  pointTerminologyOther,
  readOnly,
  onSelectReward,
  pointsPillWidth,
  onPointsPillLayout,
}: RewardsMenuProps) => (
  <VStack
    gap={4}
    backgroundColor="surface-primary"
    borderColor="surface-dividers"
    borderRadius="2"
    borderWidth={1}
    padding={4}
  >
    <VStack gap={1}>
      <Text variant="mainHeading" fontWeight="bold" color="text-primary">
        {t`Rewards Menu`}
      </Text>
      <Text variant="mainSmallMedium" color="text-secondary">
        {t`Here are rewards you can get with your ${pointTerminologyOther}`}
      </Text>
    </VStack>
    <RewardRows
      rewards={rewards}
      {...{
        pointTerminologyOne,
        pointTerminologyOther,
        readOnly,
        onSelectReward,
        pointsPillWidth,
        onPointsPillLayout,
      }}
    />
  </VStack>
);

type RewardRowsProps = RewardsMenuProps;

const RewardRows = ({
  rewards,
  pointTerminologyOne,
  pointTerminologyOther,
  readOnly,
  onSelectReward,
  pointsPillWidth,
  onPointsPillLayout,
}: RewardRowsProps) => (
  <VStack gap={2}>
    {rewards.length > 0 ? (
      rewards.map((reward) => (
        <RewardRow
          key={reward.id}
          reward={reward}
          pointTerminologyOne={pointTerminologyOne}
          pointTerminologyOther={pointTerminologyOther}
          readOnly={readOnly}
          onSelectReward={onSelectReward}
          pointsPillWidth={pointsPillWidth}
          onPointsPillLayout={onPointsPillLayout}
        />
      ))
    ) : (
      <Box backgroundColor="surface-primary" px={4} py={2}>
        <Text variant="mainSmallSemiBold" color="text-secondary">
          {t`None`}
        </Text>
      </Box>
    )}
  </VStack>
);
